import { cloudApiClient } from '@/services/clientSideCloudApiService';

export interface TagType {
  id: number;
  name: string;
}

export const getTags = async () => {
  const { data: response } = await cloudApiClient.get('tags');
  return response.data as TagType[];
};
